import { Geo } from "@aws-amplify/geo";
import { ILocation, normalizeLocation } from "./models/ILocation";
import { IAddress } from "./models/Models";
import { getModuleLog } from "./Logger";
import { GOOGLE_API_KEY } from "./Constants";
import { alpha2ToAlpha3 } from "i18n-iso-countries";

export async function reverseGeocode(location: ILocation): Promise<IAddress | undefined> {
    return reverseGeocodeGoogle(location);
}
export async function reverseGeocodeGoogle(location: ILocation): Promise<IAddress | undefined> {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.lat},${location.lon}&key=${GOOGLE_API_KEY}`;
    const result: any = await new Promise(function (resolve, reject) {
        window
            .fetch(url, {
                method: "GET",
            })
            .then((response) => {
                if (response.status !== 200) {
                    reject({ status: response.status, msg: response.statusText });
                } else {
                    resolve(response.json());
                }
            })
            .catch((response) => {
                reject({ status: response.status, msg: response.statusText });
            });
    }).catch((error) => {
        getModuleLog("reverse-geocode").error(
            `Failed to reverse geocode for [${location.lat.toFixed(5)}, ${location.lon.toFixed(
                5
            )}] : ${error}`
        );
        return undefined;
    });

    if (result) {
        const address = new Map<string, any>();
        for (const r of result.results) {
            for (const c of r.address_components) {
                address.set(c.types[0], c);
            }
        }
        const cc2 = address.get("country")?.short_name;
        const country = cc2 ? alpha2ToAlpha3(cc2) : undefined;
        return {
            state: address.get("administrative_area_level_1")?.long_name,
            postcode: address.get("postal_code")?.short_name,
            suburb: address.get("administrative_area_level_2")?.long_name,
            country: country,
            streetNumber: address.get("street_number")?.short_name,
            street: address.get("route")?.short_name,
            timezone: undefined,
        };
    }
    return undefined;
}

export async function reverseGeocodeAmplify(location: ILocation): Promise<IAddress | undefined> {
    try {
        location = normalizeLocation(location);
        const result = await Geo.searchByCoordinates([location.lon, location.lat], {
            maxResults: 1,
        });

        if (result) {
            return {
                state: result.region,
                postcode: result.postalCode,
                suburb: result.municipality,
                country: result.country,
                streetNumber: result.addressNumber,
                street: result.street,
                timezone: (result as any)?.timeZone?.name ?? undefined,
            };
        }
    } catch (error: any) {
        getModuleLog("reverse-geocode").error(
            `Failed to reverse geocode for [${location.lat.toFixed(5)}, ${location.lon.toFixed(
                5
            )}] : ${error}`
        );
    }
    return undefined;
}
